module.exports = __webpack_public_path__ + "img/whatsapp.7e49cad.svg?v=1747398688961";